import { CrudSorting } from "@refinedev/core";

export const generateSort = (sorters?: CrudSorting) => {
  if (sorters && sorters.length > 0) {
    if(sorters[0].order === 'asc')
      return `$sort[${sorters[0].field}]=1`
    else if(sorters[0].order === 'desc')
      return `$sort[${sorters[0].field}]=-1`
  }
  return;
};
